import React, { useState, useEffect } from 'react'
import './ModemSettings.css';
import './UserSettings.css';
import {useTranslation} from "react-i18next";
import {Button} from "react-bootstrap";


function UserSettings({isConfirmEmail, isAdmin, missionPlannerUrl, login}){
    const { t } = useTranslation(['account']);
    const [activeTab, setActiveTab] = useState("account");
    const [email, setEmail] = useState("123");

    console.log("user settings rend");

    function MenuButton({tabName, activeImgSrc, inactiveImgSrc}) {
        return (
            <div className='menu-button' onClick={() => setActiveTab(tabName)}>
                <img className='menu-icon' src={activeTab === tabName ? activeImgSrc : inactiveImgSrc}/>
            </div>
        )
    }

    function Account(){
        return(
            <div className='console-account'>
                {isConfirmEmail ? <></> : <p>{t('email_not_confirmed')}</p>}
                <Button href="api/user/logout">{t('logout')}</Button>
                {isAdmin ? 
                    <div className='admin-settings'>
                        <Button href="settings">Settings</Button>
                        <Button href="statistics">Statistics</Button>
                        <Button href="onlineDrones">Online</Button>
                        <Button href="users">Users</Button>
                        <Button href="firmware">Firmware</Button>
                    </div> : <></>}
            </div>
        )
    }

    function Downloads(){
        return(
            <div className='user-downloads'>
                <GS name='Mission Planner' hrefWin={missionPlannerUrl} imgSrc='/image/MP.png'/>
                <GS name='QGroundControl' hrefWin='https://disk.yandex.ru/d/JhFZsU2wXkdi1w' imgSrc='/image/QGC.png'/>
            </div>
        )
    }

    function GS({name, hrefWin, imgSrc}){
        return(
            <div className='d-gs'>
                <div>
                    <div className='gs-logo'><img src={imgSrc} /></div>
                    <div className='gs-name'>{name}</div>
                </div>
                <div className='gs-links'>
                    <Button href={hrefWin}>Windows</Button>
                </div>
            </div>
        )
    }

    return(
        <>
            <div className='modem-settings'>
                <div className='modem-settings-menu'>
                    <MenuButton tabName="account" activeImgSrc="/image/menu/home_on.svg" inactiveImgSrc="/image/menu/home.svg"/>
                    <MenuButton tabName="downloads" activeImgSrc="/image/menu/downloads_on.svg" inactiveImgSrc="/image/menu/downloads.svg"/>
                </div>
                <div className='menu-separator'><img className='menu-separator-img' src="/image/menu/separator.svg"/></div>
                <div>
                    <div className='modem-settings-label'>
                        <div>
                            {activeTab === "account" && <>{login}</>}
                            {activeTab === "downloads" && t('downloads')}
                        </div>
                    </div>
                    <div className='settings-tab'>
                        {activeTab === "account" && <Account/>}
                        {activeTab === "downloads" && <Downloads/>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserSettings;